export enum DeliveryMethod {
  Email = 'EMAIL',
  Sms = 'SMS'
}
